import React from "react";
import { Select, MenuItem, ListItemText, ListItemIcon, Box } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Tooltip as ReactTooltip } from "react-tooltip";

const ManageFolderModal = ({
  isOpen,
  folderNameText,
  selectedLanguage,
  selectedOption,
  options,
  handleManageCloseModal,
  handleCreatefolderChange,
  handleSelectFolderAccess,
  handleEditFn,
  handlerModelUpdateConfirm,
  handlerModelDeleteConfirm,
  showIcon,
  EditIcon
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal"
      id="MoveFolder"
      style={{ display: "block", backgroundColor: "#8080801c" }}>
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content">
          <div className="modal-header pb-1">
            <h4
              className="d-flex align-items-center text-danger fw-bold "
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_ManageFolder}
            </h4>
            <button
              type="button"
              className="btn btn-outline-danger Readerclose modalclose download "
              onClick={() => handleManageCloseModal()}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>
          <div className="modal-body d-flex flex-column pb-2">
            <div className="row d-flex align-items-center">
              <div className="col-sm-3 ps-3">
                <p
                  className="col-form-label font-w500"
                  style={{ fontSize: "15px" }}>
                  {selectedLanguage.LstLanguageCodes.UI_FolderName}
                </p>
              </div>
              <div className="col-sm-9 pe-3 ps-0">
                <input
                  type="text"
                  className="form-control red-shadow border-r4 custom-inputBorder"
                  id="Createfoldername" style={{ height: '49px' }}
                  maxLength={20}
                  value={folderNameText}
                  onChange={(e) => handleCreatefolderChange(e)}
                  placeholder={
                    selectedLanguage.LstLanguageCodes.UI_EnterFoldername
                  }
                  title={selectedLanguage.LstLanguageCodes.UI_EnterFoldername}
                />
              </div>
            </div>
            {localStorage.getItem("UserRole") != "RDocsUser" &&
              localStorage.getItem("UserRole") != "RDocsSupportAdmin" && (
                <div className="row align-items-center d-flex">
                  <div className="col-sm-3 ps-3">
                    <p
                      className="col-form-label font-w500 "
                      style={{ fontSize: "15px" }}>
                      {selectedLanguage.LstLanguageCodes.UI_Folderaccess}:
                    </p>
                  </div>

                  <div className="col-sm-9 pe-3 ps-0">
                    <Box sx={{ width: "100%", margin: "20px 0" }}>
                      <div className={`d-flex align-items-center ${selectedOption !== "0" ? "custom-inputBorder" : ""}`}>
                        <Select
                          className="w-100 me-2 manage-select"
                          id="dropdown-without-label"
                          displayEmpty
                          value={selectedOption}
                          onOpen={(e) => showIcon(e)}
                          onChange={handleSelectFolderAccess}
                          sx={{
                            width: "100%", backgroundColor: "#fff", borderRadius: "4px", border: selectedOption === "0" ? "1px solid #adadad !important" : "unset", borderRight: selectedOption !== "0" ? "1px solid #adadad !important" : "", "& .MuiSelect-select":
                            {
                              padding: "12px 16px",
                              color: "#000 !important",
                              fontSize: "16px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": { border: "0px !important", },
                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "0px !important", },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "0px !important", },
                            "&.Mui-focused": { boxShadow: "none !important", },
                            "& .MuiOutlinedInput-root": { boxShadow: "none !important", },
                            "& .MuiSvgIcon-root": { color: "#000", },
                          }}>
                          {options.map((option, i) => (
                            <MenuItem key={option.value} value={option.value}>
                              <ListItemText primary={option.label} />
                              {selectedOption !== option.value && (
                                <ListItemIcon>
                                  <div style={{ float: "right" }}>
                                    <InfoIcon
                                      id={option.value + i}
                                      data-toggle="tooltip"
                                      data-html="true"
                                    />
                                    <ReactTooltip
                                      className="folderAccess-tooltip"
                                      style={{ opacity: 1 }}
                                      anchorId={option.value + i}
                                      place="left">
                                      <table className="tooltip-table">
                                        <tr>
                                          <td>
                                            <div className="d-flex flex-column p-1">
                                              <p className="tooltip-text mb-0">
                                                {" "}
                                                {option.value == "0"
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_myfolderInfo
                                                  : option.value == "1"
                                                    ? selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_SpecificFolderInfo
                                                    : selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_EveryoneFolderInfo}
                                              </p>
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                    </ReactTooltip>
                                  </div>
                                </ListItemIcon>
                              )}
                            </MenuItem>
                          ))}
                        </Select>
                        {selectedOption !== "0" ? (
                          <img
                            src={EditIcon}
                            className="manageFolder-editicon"
                            alt="logo"
                            onClick={() => handleEditFn()}
                            style={{
                              cursor: "pointer",
                              width: "25px",
                              marginTop: "20px",
                              marginRight: "12px",
                            }}
                            title={
                              selectedLanguage.LstLanguageCodes.UI_SelectUsers
                            }
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Box>

                  </div>
                </div>
              )}
          </div>
          <div className="d-flex justify-content-end mb-3 me-3 mt-2">
            <button
              type="button"
              className="btn btn-primary px-4 me-1"
              data-bs-dismiss="modal"
              onClick={(e) => handlerModelUpdateConfirm()}>
              {selectedLanguage.LstLanguageCodes.UI_Save}
            </button>
            <button
              type="button"
              className="btn btn-danger px-4 ms-3"
              onClick={(e) => handlerModelDeleteConfirm()}>
              {selectedLanguage.LstLanguageCodes.UI_DeleteFolder}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageFolderModal;
